import { dataUpdateWave } from 'dls-icons-data'
import { createIcon } from '../common'

const IconUpdateWave = /*#__PURE__*/createIcon(dataUpdateWave)
export default IconUpdateWave
